import React from 'react'

// Global reducer
import { useState } from '../../../../../../../hooks'

import Filter from './Filter'
import Table from './Table'

const TribologySamplesInsertMassiveExcelForm = ({ onIdChange }) => {
  const [data, setDataState] = useState()

  const handleDataChange = (data) => {
    setDataState(data)
  }

  const handleIdChange = (id) => {
    onIdChange(id)
  }

  const handleBack = () => {
    setDataState()
  }

  if (data)
    return <Table data={data} onBack={handleBack} onIdChange={handleIdChange} />

  return <Filter onDataChange={handleDataChange} />
}

export default TribologySamplesInsertMassiveExcelForm
